import { cpManagementGroupsRoute } from '@/modules/administration/charge-point-management/groups/routes';
import { cpManagementIndexRoute } from '@/modules/administration/charge-point-management/index/routes';
import { cpManagementRoute } from '@/modules/administration/charge-point-management/routes';
import { cpManagementStatusDetailRoute } from '@/modules/administration/charge-point-management/status-detail/routes';
import { cpManagementStatusRoute } from '@/modules/administration/charge-point-management/status/routes';
import { contractsRoute } from '@/modules/administration/contracts/routes';
import { fleetManagementRoute } from '@/modules/administration/fleet-management/routes';
import { fleetTripHistoryDetailRoute } from '@/modules/administration/fleet-trip-history/details/routes';
import { fleetTripHistoryIndexRoute } from '@/modules/administration/fleet-trip-history/index/routes';
import { fleetTripHistoryRoute } from '@/modules/administration/fleet-trip-history/routes';
import { adminIndexRoute } from '@/modules/administration/index/routes';
import { adminRoute } from '@/modules/administration/routes';
import { groupsDetailRoute } from '@/modules/administration/user-management/groups-detail/routes';
import { groupsRoute } from '@/modules/administration/user-management/groups/routes';
import { userManagementIndexRoute } from '@/modules/administration/user-management/index/routes';
import { userManagementRoute } from '@/modules/administration/user-management/routes';
import { usersRoute } from '@/modules/administration/user-management/users/routes';

const adminRouteTree = adminRoute.addChildren([
  adminIndexRoute,
  contractsRoute,
  userManagementRoute.addChildren([
    userManagementIndexRoute,
    usersRoute,
    groupsRoute,
    groupsDetailRoute,
  ]),
  cpManagementRoute.addChildren([
    cpManagementIndexRoute,
    cpManagementStatusRoute,
    cpManagementGroupsRoute,
    cpManagementStatusDetailRoute,
  ]),
  fleetManagementRoute,
  fleetTripHistoryRoute.addChildren([fleetTripHistoryIndexRoute, fleetTripHistoryDetailRoute]),
]);

export default adminRouteTree;
